export const hideSeeLessButton = () => dispatch => {
  dispatch({ type: "UPDATE_SEE_LESS", payload: { visible: false } });
};

export const showSeeLessButton = payload => dispatch => {
  dispatch({
    type: "UPDATE_SEE_LESS",
    payload: { visibility: true, target: payload },
  });
};

export const showLessFor = payload => dispatch => {
  
  
}
